import { Breadcrumb, Col, Row } from "antd";
import Title from "../../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import ReturnInvoicesList from "./ReturnInvoicesList";

function ReturnsInvoices() {
  const { t } = useTranslation("common");

  const resetFilters = () => {};

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              {
                title: <>{t("bills-list")}</>,
              },
              {
                title: <>{t("invoices")}</>,
              },
              {
                title: (
                  <>
                    <span className="breadcrumbcolor"> {t("returns")} </span>
                  </>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("return")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search value={""} onKeyPress={""} onChange={""} />
        </Col>
        <Col
          offset={12}
          span={6}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => ""} />
        </Col>
        <Col offset={1} span={22}>
          <ReturnInvoicesList />
        </Col>
      </Row>
    </>
  );
}

export default ReturnsInvoices;
